
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic17Static as ObiHydraulic17StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-17-static.js';
 
 
 

 
 export const ObiHydraulic17Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-17-static',
   elementClass: ObiHydraulic17StaticElement,
   events: {
     
   }
  });
 
 